import ScanConsultantReviewDTO from '@src/adapters/dto/scan/ScaneConsultantReviewDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  scanId: string;
  consultantId: string | null;
  procedureId: string | null;
}

interface Result {
  scan: ScanConsultantReviewDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/scan/reassign',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveScanReassign = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveScanReassignLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveScanReassign;
